import React, { FunctionComponent } from "react";
import {
  Box,
} from "@chakra-ui/react";

import { useAllSitesData } from "common/all-sites-data";
import { useUserPreference } from "common/user-preferences";

import Alert from "./Alert";
import MuteButton from "./MuteButton";


interface IProps {
  bg: string;
  hoverBg: string;
}


const Alerts: FunctionComponent<IProps> = ({
  bg,
  hoverBg,
}) => {
  const [ mutedAlerts ] = useUserPreference<boolean>("ui__muted_alerts");
  const { alertsData } = useAllSitesData();

  return (
    <>
      {<Box>
        {mutedAlerts && <MuteButton
          bg={ bg }
          hoverBg={ hoverBg }
        />}

        {alertsData && <Alert
          alert={alertsData}
        />}
      </Box>}
    </>
  );
};

export default Alerts;
